export function filterProductsByStatus(data, status) {
    const newArr = data?.filter((item) => item.status === status)
    return newArr
}
